import { render, staticRenderFns } from "./OwnerActionCell.vue?vue&type=template&id=1b374a78"
import script from "./OwnerActionCell.vue?vue&type=script&lang=js"
export * from "./OwnerActionCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports